export const ScrollToPositionFixed = (pos, scroll) => {
  if (pos) {
    const top = parseInt(document.querySelector('html').style.top) * -1;
    document.querySelector('html').classList.remove('fixed');
    document.querySelector('html').style.top = '0px';
    window.scrollTo(0, top)
  } else {
    document.querySelector('html').classList.add('fixed');
    document.querySelector('html').style.top = '-'+ scroll +'px';
  }
};